import { useSelector } from "react-redux";
import { Fragment } from "react";
import { RichTextDisplay } from "../../components/form/RichTextEditor.jsx";
import AdminQrCode from "../../components/display/AdminQrCode.jsx";

const ChallengeDetails = () => {
    const { challengeDetails } = useSelector((state) => state.challenge);
    return (
        <Fragment>
            <div className="row fs-7 mb-3">
                <div className="col-md-6">
                    <strong className="fs-7">Title: </strong>
                    <p>{challengeDetails?.name || null}</p>
                </div>
                <div className="col-md-6">
                    <strong className="fs-7">Description: </strong>
                    <div className="text-justify">
                        <RichTextDisplay html={challengeDetails?.description} fallback="—" />
                    </div>
                </div>
            </div>
            <div className="row fs-7 mb-3">
                <div className="col-md-6">
                    <strong className="fs-7">Start Time </strong>
                    <p>{challengeDetails?.in_time_str || "NA"}</p>
                </div>
                <div className="col-md-6">
                    <strong className="fs-7">End Time </strong>
                    <p>{challengeDetails?.out_time_str || "NA"}</p>
                </div>
            </div>
            <div className="row fs-7 mb-3">
                <div className="col-md-6">
                    <strong className="fs-7">Unique Code: </strong>
                    <p>{challengeDetails?.otp || null}</p>
                </div>
                <div className="col-md-6">
                    <strong className="fs-7">QR Code: </strong>
                    <AdminQrCode
                        src={challengeDetails?.qrcode || challengeDetails?.qr_code}
                        otp={challengeDetails?.otp}
                        label="Quest"
                        size={180}
                    />
                </div>
            </div>
        </Fragment>

    )
}

export default ChallengeDetails;